export default __webpack_public_path__ + "assets/images/1a9364aa68acc7d3492cb25086658854.jpg";